import globalAgent from 'src/agent';
import { URLS } from 'src/constants/urls';

import type { AxiosPromise } from 'axios';
import type {
    Subscription,
    PromoCheckResponse,
    PaymentRequest,
    PaymentResponse,
    PromoCode,
    PromoCodeUpdate,
    Referral,
} from 'src/types/Subscription';

export const getSubscriptions = (): AxiosPromise<Subscription[]> => {
    return globalAgent.get(URLS.SUBSCRIPTIONS);
};

export const getCustomPlanSettings = (): AxiosPromise<{
    base_price: string;
    project_price: string;
    keyword_price: string;
    bundle_price: string;
    chat_price: string;
    ai_analysis_price: string;
    color_code?: string;
    custom_description?: string;
}> => {
    return globalAgent.get(URLS.SUBSCRIPTIONS_CUSTOM_PLAN_SETTINGS);
};

export const checkPromocode = (promo_code: string): AxiosPromise<PromoCheckResponse> => {
    return globalAgent.post(URLS.SUBSCRIPTIONS_VALIDATE_PROMO_CODE, { promo_code: promo_code.toUpperCase() });
};

export const getMyPromocode = (): AxiosPromise<PromoCode> => {
    return globalAgent.get(URLS.SUBSCRIPTIONS_MY_PROMOCODE);
};

export const updateMyPromocode = (data: PromoCodeUpdate): AxiosPromise<PromoCode> => {
    return globalAgent.patch(URLS.SUBSCRIPTIONS_MY_PROMOCODE, { code: data.code.toUpperCase() });
};

export const getMyReferrals = (): AxiosPromise<Referral[]> => {
    return globalAgent.get(URLS.SUBSCRIPTIONS_MY_REFERRALS);
};

export const createPayment = (body: PaymentRequest): AxiosPromise<PaymentResponse> => {
    console.log('SubscriptionsService.createPayment - получен body:', body);
    console.log('SubscriptionsService.createPayment - промокод в body:', body.promo_code);
    const requestBody = { ...body };
    console.log('SubscriptionsService.createPayment - requestBody после spread:', requestBody);
    console.log('SubscriptionsService.createPayment - промокод в requestBody:', requestBody.promo_code);
    console.log('URL:', URLS.SUBSCRIPTIONS_CREATE_PAYMENT);
    return globalAgent.post(URLS.SUBSCRIPTIONS_CREATE_PAYMENT, requestBody);
};

export const cancelPayment = (): AxiosPromise<unknown> => {
    return globalAgent.post(URLS.SUBSCRIPTIONS_CANCEL);
};
